export default __webpack_public_path__ + "static/media/garage.8773ad2d.png";